import React from "react";

function HorizonatlSeprator({ width = "420" }) {
	return (
		<svg
			width={width}
			height="2"
			viewBox="0 0 420 2"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path d="M0 1H420" stroke="#D1CED4" />
		</svg>
	);
}

export default HorizonatlSeprator;
